import { useServerStatus } from "@/hooks/useServerStatus";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { RefreshCw, Server, MessageSquare, MessageCircle } from "lucide-react";

export const ServerStatus = () => {
  const { 
    isOnline, 
    whatsappConnected, 
    telegramConnected, 
    activeConnections,
    isLoading,
    refetch 
  } = useServerStatus();

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Status do Servidor</CardTitle>
        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => refetch()}
          disabled={isLoading}
        >
          <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
        </Button>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Server className="h-4 w-4" />
            <span>Servidor VPS</span>
          </div>
          <Badge variant={isOnline ? "default" : "destructive"}>
            {isOnline ? "Online" : "Offline"}
          </Badge>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <MessageSquare className="h-4 w-4" />
            <span>WhatsApp</span>
          </div>
          <Badge variant={whatsappConnected ? "default" : "destructive"}>
            {whatsappConnected ? "Conectado" : "Desconectado"}
          </Badge>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <MessageCircle className="h-4 w-4" />
            <span>Telegram</span>
          </div>
          <Badge variant={telegramConnected ? "default" : "destructive"}>
            {telegramConnected ? "Conectado" : "Desconectado"}
          </Badge>
        </div>

        <div className="mt-4 text-sm text-muted-foreground">
          Conexões ativas: {activeConnections}
        </div>
      </CardContent>
    </Card>
  );
};